export const isStatus = <S extends Record<string, unknown>>(
  statuses: S,
  record: object | null | undefined,
  recordField: string,
  ...expectations: (keyof S)[]
): boolean =>
  !!record &&
  (expectations.map((name) => statuses[name]) as unknown[]).includes(
    (record as Record<string, unknown>)[recordField],
  )

export const getStatus = <T extends Record<string, string | number>>(
  statuses: T,
  value: T[keyof T],
): keyof T | undefined => {
  const inverted = Object.entries(statuses).reduce(
    (acc, [key, val]) => {
      acc[val as string | number] = key
      return acc
    },
    {} as Record<string | number, string>,
  )
  return inverted[value as string | number] as keyof T | undefined
}
